var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTypeChoose = function SvgIconTypeChoose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_type_choose_svg2__a",
    x1: 94.42,
    x2: 428.42,
    y1: 439.95,
    y2: 121.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_type_choose_svg2__a",
    id: "icon_type_choose_svg2__b",
    x1: -51.97,
    x2: 282.03,
    y1: 286.2,
    y2: -31.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_type_choose_svg2__a",
    id: "icon_type_choose_svg2__c",
    x1: 75.25,
    x2: 409.25,
    y1: 419.82,
    y2: 101.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_type_choose_svg2__a",
    id: "icon_type_choose_svg2__d",
    x1: -22.6,
    x2: 311.4,
    y1: 317.04,
    y2: -0.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_type_choose_svg2__a",
    id: "icon_type_choose_svg2__e",
    x1: -51.97,
    x2: 282.03,
    y1: 286.2,
    y2: -31.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_type_choose_svg2__a",
    id: "icon_type_choose_svg2__f",
    x1: 75.26,
    x2: 409.26,
    y1: 419.82,
    y2: 101.82
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m409.92 404.3-3.72.63c-4.8-21.15 5.53-34.53 12.63-55.99 8.72-23.31 8.76-55.3.14-106.95l-5.88-34.89c-1.76-10.77-11.91-18.08-22.68-16.32a.4.4 0 0 0-.11.02 33.8 33.8 0 0 0-15.4 4.62c-3.34-8.96-12.55-14.3-21.99-12.75-5.38.34-10.61 1.94-15.26 4.66-3.32-8.94-12.52-14.28-21.93-12.74-5.29.29-10.44 1.81-15.05 4.42L296.31 153c14.68 1.57 27.78-7.25 28.03-22.73V22.73C324.33 10.18 314.16.01 301.61 0H194.09c-12.55.01-22.72 10.18-22.73 22.73v107.52c.01 12.55 10.18 22.72 22.73 22.73h53.6l9.13 88.22c1.29 7.31-.93 45.28-.97 53.41-.02.75-.65 1.34-1.39 1.31-.27 0-.53-.09-.74-.25l-38.88-24.36a34.27 34.27 0 0 0-33.74-1.36l-6.06 3.14c-6.27 3.36-8.63 11.16-5.27 17.43.44.83.98 1.61 1.59 2.32l92.49 105.45a56.4 56.4 0 0 1 13.33 28.29l-3.74.63c-6.18 1.06-10.34 6.9-9.34 13.09l9.22 54.97a5.696 5.696 0 0 0 6.54 4.67l147.7-24.78a5.73 5.73 0 0 0 4.67-6.54l-9.22-54.98c-1.05-6.18-6.9-10.35-13.08-9.32ZM194.08 141.62c-6.27 0-11.36-5.09-11.37-11.37V22.73c0-6.27 5.09-11.36 11.37-11.37H301.6c6.27 0 11.36 5.09 11.37 11.37v107.52c0 6.27-5.09 11.36-11.37 11.37h-7.21c-1.74-8.78-1.79-22.43-10.52-27.65-6.15-4.89-14.61-3.79-21.79-2.21-10.63 1.83-17.88 11.79-16.34 22.47l.76 7.39h-52.43Zm78.31 249.18-92.5-105.46a1.38 1.38 0 0 1 .4-2.17l6.02-3.11a22.84 22.84 0 0 1 22.49.9l38.89 24.37c6.02 3.71 13.92 1.83 17.63-4.19a12.8 12.8 0 0 0 1.89-6.18c.04-9.54 2.36-46.18.9-55.02l-9.59-92.59c.02-.05-.01-.1-.02-.15l-1.5-14.46c-.76-4.62 2.35-8.99 6.97-9.76l6.98-1.19c4.61-.77 8.97 2.34 9.76 6.94l11.62 69.26 7.15 42.5c.52 3.1 3.45 5.18 6.55 4.66s5.18-3.45 4.66-6.55l-7.12-42.3a8.603 8.603 0 0 1 7.03-9.36l7-1.14a8.54 8.54 0 0 1 9.77 6.95l2.3 13.75.04.24 5.8 34.87a5.68 5.68 0 0 0 6.6 4.58 5.68 5.68 0 0 0 4.61-6.44l-5.81-34.91c-.78-4.6 2.3-8.96 6.89-9.74.03 0 .06 0 .09-.01l6.9-1.2a8.58 8.58 0 0 1 9.82 6.95l2.34 13.95 4.68 27.98c.52 3.1 3.45 5.19 6.54 4.67 3.1-.52 5.19-3.45 4.67-6.54l-4.68-27.98c-.73-4.6 2.35-8.92 6.91-9.74l7.09-1.14c4.59-.76 8.93 2.34 9.7 6.94v.02l5.88 34.91c8.27 49.55 8.4 79.79.42 101.1-8.04 23.06-18.49 38.66-13.19 61.85l-106.61 17.87a67.7 67.7 0 0 0-15.98-33.87Zm11.19 96.98-8.28-49.36 121.17-20.34 6-1.01 9.31-1.56 8.29 49.38-136.5 22.9Z",
    style: {
      fill: "url(#icon_type_choose_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.67 99.14H48.26c-9.41.01-17.04 7.64-17.05 17.05v76.41c.01 9.41 7.64 17.04 17.05 17.05h76.41c9.41-.01 17.04-7.64 17.05-17.05v-76.41c-.01-9.41-7.64-17.04-17.05-17.05m5.68 93.47c0 3.14-2.55 5.68-5.68 5.68H48.26c-3.14 0-5.68-2.55-5.68-5.68V116.2c0-3.14 2.55-5.68 5.68-5.68h76.41c3.14 0 5.68 2.55 5.68 5.68z",
    style: {
      fill: "url(#icon_type_choose_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.74 42.49h-76.41c-9.41.01-17.04 7.64-17.05 17.05v76.41c.01 9.41 7.64 17.04 17.05 17.05h76.41c9.41-.01 17.04-7.64 17.05-17.05V59.54c-.01-9.41-7.64-17.04-17.05-17.05m5.68 93.46c0 3.14-2.55 5.68-5.68 5.68h-76.41c-3.14 0-5.68-2.55-5.68-5.68V59.54c0-3.14 2.55-5.68 5.68-5.68h76.41c3.14 0 5.68 2.55 5.68 5.68z",
    style: {
      fill: "url(#icon_type_choose_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86 41.58a5.685 5.685 0 0 0-8.04 0l-41.05 41.05-21.02-21.02c-2.25-2.19-5.85-2.13-8.04.12a5.675 5.675 0 0 0 0 7.91l25.04 25.04a5.685 5.685 0 0 0 8.04 0l45.07-45.07a5.685 5.685 0 0 0 0-8.04Z",
    style: {
      fill: "url(#icon_type_choose_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.46 134.55c-10.96.1-19.76 9.07-19.66 20.03.1 10.82 8.84 19.56 19.66 19.66 10.96-.1 19.76-9.07 19.66-20.03-.1-10.82-8.84-19.56-19.66-19.66m0 28.33c-4.68-.07-8.43-3.92-8.36-8.6a8.49 8.49 0 0 1 8.36-8.36c4.68.07 8.43 3.92 8.36 8.6a8.49 8.49 0 0 1-8.36 8.36",
    style: {
      fill: "url(#icon_type_choose_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.54 77.9c-10.96.08-19.78 9.04-19.7 20 .08 10.84 8.85 19.61 19.7 19.7 10.96-.08 19.78-9.04 19.7-20-.08-10.84-8.85-19.61-19.7-19.7m0 28.33a8.47 8.47 0 0 1-8.38-8.58 8.47 8.47 0 0 1 8.38-8.38c4.68.05 8.44 3.89 8.38 8.58a8.47 8.47 0 0 1-8.38 8.38",
    style: {
      fill: "url(#icon_type_choose_svg2__f)"
    }
  }));
};
export default SvgIconTypeChoose;